import { render, staticRenderFns } from "./ClienteComandas.vue?vue&type=template&id=584b0a0c&scoped=true"
import script from "./ClienteComandas.vue?vue&type=script&lang=js"
export * from "./ClienteComandas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b0a0c",
  null
  
)

export default component.exports